import KlarnaRepository from './KlarnaRepository';

export default KlarnaRepository;
